import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { BOOLEAN_TYPES, DEFAULT_PAGE } from '../constants'

const TaskIsAwaitingFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { isAwaiting, awaitingReason } = getQueryParams(search)

  const handleChange = useCallback(
    isAwaiting =>
      history.push(
        createUrl(pathname, search, {
          isAwaiting,
          awaitingReason: isAwaiting === 'true' ? awaitingReason : '',
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search, awaitingReason],
  )

  return (
    <Form.Item label="Is awaiting">
      <Select
        style={{ width: '100%' }}
        value={isAwaiting?.toString()}
        onChange={handleChange}
        allowClear
      >
        {map(BOOLEAN_TYPES, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default TaskIsAwaitingFilter
